import { BoxListTruckService } from './../box-list-truck/box-list-truck.service';
import { Component, OnInit, Input } from '@angular/core';
import { Util } from '../shared/Util';
import { GraphicService } from '../shared/graphic.service';
import { LoadedModules } from '../shared/esri-load-control.service';
import { BoxInfoRouterService } from '../box-info-router/box-info-router.service';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { JsonReturn } from '../shared/interface/generic-interface';
import { StatusRoteiroComponent } from '../status-roteiro/status-roteiro.component';
import { NgStyle, NgIf, NgFor, DecimalPipe, CurrencyPipe, DatePipe } from '@angular/common';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { BotaoPrimarioComponent } from '../shared/componentes/botao-primario/botao-primario.component';
import { BoxInfoTruckCrossdockingComponent } from './box-info-truck-crossdocking/box-info-truck-crossdocking.component';


@Component({
    selector: 'box-info-truck',
    templateUrl: './box-info-truck.component.html',
    styleUrls: ['./box-info-truck.component.css'],
    standalone: true,
    imports: [StatusRoteiroComponent, NgStyle, NgIf, NgFor, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatSelect, MatOption, BotaoPrimarioComponent, DecimalPipe, CurrencyPipe, DatePipe, BoxInfoTruckCrossdockingComponent]
})
export class BoxInfoTruckComponent implements OnInit {

  @Input() dados;
  vlrPedagio: number;
  custoTotal: number;
  custoIdealPorcentagem: number;
  custoPorcentagem: number;
  latitudeMotorista: number;
  longitudeMotorista: number;
  dddMotorista: string;
  telefoneMotorista: number;
  versaoApp: string;
  tempoTotalRoteiro: string = '00:00'
  diasRoteiro: []
  info:any;
  idRoteiroSituacao: number;
  idRoteiro: number;
  placasVeiculos: Array<String> = [];
  nomesMotoristas: Array<String> = [];
  descricaoSituacaoRoteiro: string;
  tempoEstimado? : string;
  nomeAjudante = '';
  ajudantes = null
  custoDescarga = 0;
  custoKm = 0;
  formFiltro: FormGroup;
  showEdicao = false;
  novaPlaca = '';
  novoNomeMotorista = '';
  nomeAbreviado = '';
  caminho: string;
  color: string;
  @Input() roteiroCrossdocking = false;
  
  constructor
  (
    private fb: FormBuilder, 
    private boxListTruckService: BoxListTruckService,
    private graphicService: GraphicService,
    public util: Util,
    private boxInfoRouterService: BoxInfoRouterService,
  ) { 
    this.formFiltro = this.fb.group({
      rota1: [null, Validators.required],
      rota2: [null, Validators.required],
      rota3: [null, Validators.required],
      rota4: [null, Validators.required],

    });
  }

  async ngOnInit() 
  {
    await this.getInfoTruck();
    this.versaoApp = this.boxListTruckService.listTruckService.VersaoApp;
    await this.getTempoTotalRtoeiro();
    await this.placasVeiculosDisponiveis();
    await this.motoristasDisponiveis();
    this.idRoteiroSituacao = this.dados.IdRoteiroSituacao ?? 1;
    this.descricaoSituacaoRoteiro = Util.descricaoStatusRoteiro(this.idRoteiroSituacao)
    this.idRoteiro = this.dados.IdRoteiro;

    await this.atualizaQtdEntrega();
    this.nomeAbreviado = this.abreviarNomeCompleto(this.info.nome_motorista)
    this.caminho = this.getCaminho();
    this.color = this.getCorSituacao();    
  }

  async getInfoTruck() 
  {
    const response = this.dados;
    this.info = response;

    let vetInfoRota = JSON.parse(response.InfoRota);
    
    let infoRoteirizacao = vetInfoRota.InfoRoteirizacao   ?? null   
   infoRoteirizacao?.totalCustoDescarga ?? 0 

    this.latitudeMotorista = vetInfoRota.LatitudeMotorista
    this.longitudeMotorista = vetInfoRota.LongitudeMotorista
    this.dddMotorista = vetInfoRota.DDD;
    this.telefoneMotorista =  vetInfoRota.Telefone;
    this.vlrPedagio = vetInfoRota.ValorPedagio ?? 0;
    this.custoTotal = vetInfoRota.CustoTotal ?? 0;
    this.custoIdealPorcentagem = vetInfoRota.CustoIdealPorcentagem ?? 0;
    this.custoPorcentagem = vetInfoRota.CustoPorcentagem ?? 0;
    this.tempoEstimado = vetInfoRota.TempoEstimado ?? null;
    this.nomeAjudante = vetInfoRota.NomeAjudante ?? '';
    this.custoDescarga = infoRoteirizacao?.totalCustoDescarga ?? 0
    this.custoKm = vetInfoRota.CustoKM ?? 0
    this.ajudantes = vetInfoRota.Ajudante ?? null

    if (vetInfoRota.RetornoMotorista) {
      let symbol = new LoadedModules.PictureMarkerSymbol
        ({
          'url': 'assets/img/icon-ponto-partida-motorista.png',
          'height': 38,
          'width': 26,
          'contentType': 'image/svg+xml'
        });
      let g = new LoadedModules.Graphic({
        geometry: this.graphicService.CriaPontoMapa(this.latitudeMotorista, this.longitudeMotorista),
        symbol: symbol
      });
      this.graphicService.addGraphic(g, false);
    }

  }

  async getTempoTotalRtoeiro(){
    let response: JsonReturn = await this.boxListTruckService.getTempoTotalRtoeiro(this.info.IdRoteiro)
    this.diasRoteiro = response.response;
    
    let minutos = 0;
    this.diasRoteiro.forEach((dia: any) => {
      minutos += Util.converterMinutos(dia.HoraCalcAcumuladaT);
    })   
    this.tempoTotalRoteiro = Util.converteStringHora(minutos);   
  }

  async placasVeiculosDisponiveis(){
    const placasVeiculosDisponiveis = await this.boxListTruckService.placasVeiculosDisponiveis()  
    placasVeiculosDisponiveis.forEach(placa => {
        this.placasVeiculos.push(placa.PlacaVeiculo)        
    });
    this.placasVeiculos.sort();
  }

  async motoristasDisponiveis(){
    const nomesMotoristasDisponiveis = await this.boxListTruckService.motoristasDisponiveis()  
    nomesMotoristasDisponiveis.forEach(motor => {
      this.nomesMotoristas.push(motor.NomeMotorista)        
    });   
  }

  async alterarPlaca(novaPlaca){
    this.novaPlaca = novaPlaca;   
  }
  async alterarNome(novoNome){
    this.novoNomeMotorista = novoNome;   
  }

  getCorSituacao(): string {
    switch (this.descricaoSituacaoRoteiro) {
      case 'Não iniciado':
        return '#CFD8DC';
      case 'Em rota':
        return '#81D4FA';
      case 'Pausado':
        return '#FFCC80';
      case 'Sem sinal':
        return '#EF9A9A';
      case 'Finalizado':
        return '#7FF3B9';
      default:
        return 'white';
    }
  }
  getCaminho(){
    switch (this.descricaoSituacaoRoteiro){
      case 'Não iniciado':
        return 'assets/img/icons/icon-status-aberto.svg';
      case 'Em rota':
        return 'assets/img/icons/icon-status-iniciado.svg';
      case 'Pausado':
        return 'assets/img/icons/icon-status-pausado.svg';
      case 'Sem sinal':
        return 'assets/img/icons/icon-status-sem-sinal.svg';
      case 'Finalizado':
        return 'assets/img/icons/icon-status-finalizado.svg';
      default:
        return 'white';
    }
  }

  async atualizaQtdEntrega(): Promise<void>{
    let infoRota: any = JSON.parse(this.dados.InfoRota) ?? false;
    let consideraEndPed = infoRota.ConsideraEndPed? true: false;
    if(consideraEndPed){
      await this.boxInfoRouterService.getInfoRouter();
      if (this.boxInfoRouterService.infoRouter) {
        const pontosUnicos = new Set(
          this.boxInfoRouterService.infoRouter.map((item: any) =>
            item.IdCliente ? `id_${item.IdCliente}` : `${item.CodigoCliente}_${item.Latitude}_${item.Longitude}`
          )
        );
        this.info.QtdeEntregas = pontosUnicos.size;
      }
    }
  }

  abreviarNomeCompleto(nomeCompleto: string): string {
    let partesDoNome = nomeCompleto.split(' ');

    if (partesDoNome.length >= 2) {
      let primeiroNome = partesDoNome[0];
      let segundaParte = partesDoNome[1];
      let inicialSegundoNome = segundaParte.charAt(0) + '.';
      return `${primeiroNome} ${inicialSegundoNome}`;
    }

    return nomeCompleto;
  }

  toggleEdicao() {
    this.showEdicao = !this.showEdicao;
    if(this.showEdicao){
      this.novaPlaca = this.info.cod_veiculo
      this.novoNomeMotorista = this.info.nome_motorista
    }
  }

  async salvaEdicao(){
    this.info.cod_veiculo = this.novaPlaca;
    this.info.nome_motorista = this.novoNomeMotorista;
    this.nomeAbreviado = this.abreviarNomeCompleto(this.novoNomeMotorista);
    this.showEdicao = false;
    await this.boxListTruckService.atulizaPlacasVeiculosDisponiveis(this.idRoteiro, this.novaPlaca);
    await this.boxListTruckService.atulizaNomeMotoristaDisponiveis(this.idRoteiro, this.novoNomeMotorista);
  }
  
}